/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const resetPasswordRequestV4Schema = z.object({
  token: z.string().nullish().describe('The one-time token from the emailed reset link.'),
  newPassword: z
    .string()
    .nullish()
    .describe('The new password (min 8 chars, with upper, lower and a digit).'),
})
